/*
 * @Author: yanxia@tencent.com
 * @Date: 2022-04-07 19:37:53
 * @LastEditors: jesseding
 * @LastEditTime: 2022-06-21 11:37:59
 * @Description: file content
 */
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import { initCoChannel } from './lib/coChannel';
import { getResizeRatio, updateFontSize } from './lib/mobileResize';

updateFontSize(getResizeRatio());
initCoChannel();

ReactDOM.render(<App />, document.getElementById('root'));
